module.exports = __webpack_public_path__ + "img/anquan.cfc9b738.png";